import React from "react";
import JhaHazards from "../component/jha/jhaHazards";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import * as jhaAction from "../../../redux/actions/jhaAction";
import { API_STATUS, PAGE_SIZE, USER_ID } from "../../../constant/constant";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import {
  ACCESS_DENIED,
  ADMIN_JHA_SET_CONTROLS,
} from "../../../constant/routeContant";
import JhaSetControlsConatiner from "./jhaSetControlsConatiner";
import { checkPrivileges } from "../../../utils/rolesHelper";

const JhaHazardsContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [page, setpage] = useState(0);

  const [shwoToast, setshwoToast] = useState(false);
  const [showControlPage, setshowControlPage] = useState(false);
  const defaultData = {
    search: "",
    isAll: 0,
    page: 1,
    pageSize: 1000,
  };
  const [catId, setCatId] = useState("");
  const [formValue, setFormValue] = useState({
    hazardsName: "",
    isGlobal: false,
    activityId: "",
    createdBy: parseInt(USER_ID()),
  });

  const [filterFormValue, setFilterFormValue] = useState({
    isActive: "",
  });

  const categoriesListData = useSelector((state) => state.jhaCategoryList);
  const activitiesListData = useSelector((state) => state.getJhaActivityList);
  const hazardsListData = useSelector((state) => state.getJhaHazardsList);
  const [listState, setlistState] = useState([]);
  const [listCountState, setlistCountState] = useState(0);
  useEffect(() => {
    if (hazardsListData?.data?.result?.itemList) {
      setlistState(hazardsListData?.data?.result?.itemList);
      setlistCountState(hazardsListData?.data?.result?.itemsCount);
    }
  }, [hazardsListData]);

  const getCategoriesListData = (data) => {
    dispatch(jhaAction.getJhaCategoryList(data));
  };
  const getJhaActivityList = (data) => {
    dispatch(jhaAction.getJhaActivityList(data));
  };
  const getJhaHazardsList = (data) => {
    dispatch(jhaAction.getJhaHazardsList(data));
    dispatch(jhaAction.getHazardConfigurationFilterObj(data));
  };
  useEffect(() => {
    dispatch(jhaAction.clearJha());
    setlistState([]);
    setlistCountState([]);
    getCategoriesListData(
      hazardsListData?.filterObjs ? hazardsListData.filterObjs : defaultData,
    );
  }, []);

  useEffect(() => {
    if (
      categoriesListData.status === API_STATUS.SUCCESS &&
      categoriesListData?.isLoading === false
      // clearalert
    ) {
      mapCategoriesKeyValue();
    }
  }, [categoriesListData]);

  useEffect(() => {
    if (categoriesListData?.filterObjs) {
      const f = categoriesListData.filterObjs;
      setpage((f.page || 1) - 1);
      setPageSize(f.pageSize || PAGE_SIZE);
      setFilterFormValue({
        ...filterFormValue,
        isActive: f.status === true ? 1 : f.status === false ? 2 : "",
      });
    }
  }, [categoriesListData?.filterObjs]);

  useEffect(() => {
    if (catId !== "")
      getJhaActivityList({
        categoryId: catId,
        search: "",
        isAll: 0,
        page: 1,
        pageSize: 1000,
      });
  }, [catId]);
  useEffect(() => {
    if (formValue.activityId !== "")
      getJhaHazardsList({
        activityId: formValue.activityId,
        search: "",
        page: 1,
        pageSize: PAGE_SIZE,
        status:
          filterFormValue.isActive === 1
            ? true
            : filterFormValue.isActive === 2
              ? false
              : "",
      });
  }, [formValue.activityId]);

  useEffect(() => {
    if (
      activitiesListData.status === API_STATUS.SUCCESS &&
      activitiesListData?.isLoading === false
      // clearalert
    ) {
      mapActivityKeyValue();
    }
  }, [activitiesListData]);

  const [categoriesList, setcategoriesList] = useState([]);
  function mapCategoriesKeyValue() {
    let arr = [];
    categoriesListData?.data?.result?.itemList.map((i) =>
      arr.push({
        key: i.id,
        value: i.categoryName,
      }),
    );
    setcategoriesList(arr);
  }

  const [activityList, setactivityList] = useState([]);
  function mapActivityKeyValue() {
    let arr = [];
    activitiesListData?.data?.result?.itemList.map((i) =>
      arr.push({
        key: i.id,
        value: i.activityName,
      }),
    );
    setactivityList(arr);
  }

  // add
  const addJhaHazardData = useSelector((state) => state?.addJhaHazard);
  function addJhaHazard(data) {
    setshwoToast(true);
    dispatch(jhaAction.addJhaHazard(data));
  }
  useEffect(() => {
    if (
      addJhaHazardData.status === API_STATUS.SUCCESS &&
      addJhaHazardData?.isLoading === false &&
      shwoToast
      // clearalert
    ) {
      toast("Hazard Added successfully");
      setshwoToast(false);
      setPageSize(PAGE_SIZE);
      setpage(0);
      setFilterFormValue({
        isActive: "",
      });
      getJhaHazardsList({
        activityId: formValue.activityId,
        search: "",
        page: 1,
        pageSize: PAGE_SIZE,
        status: "",
      });
    }
  }, [addJhaHazardData]);

  // edit
  const updateJhaHazardData = useSelector((state) => state?.updateJhaHazard);
  function handleEditOnClick(data) {
    setshwoToast(true);

    dispatch(jhaAction.updateJhaHazard(data));
  }

  function handleStatusChange(data) {
    let newData = {
      hazardsName: data.hazardsName,
      isGlobal: false,
      hazardsId: data.id,
      isActive: !data.isActive,
      modifiedBy: parseInt(USER_ID()),
    };
    setshwoToast(true);
    dispatch(jhaAction.updateJhaHazard(newData));
  }

  useEffect(() => {
    if (
      updateJhaHazardData.status === API_STATUS.SUCCESS &&
      updateJhaHazardData?.isLoading === false &&
      shwoToast
      // clearalert
    ) {
      toast("Hazard Updated successfully");
      setshwoToast(false);
      if (categoriesListData?.filterObjs) {
        getJhaHazardsList(categoriesListData.filterObjs);
      } else {
        getJhaHazardsList({
          activityId: formValue.activityId,
          search: "",
          page: 1,
          pageSize: PAGE_SIZE,
          status:
            filterFormValue.isActive === 1
              ? true
              : filterFormValue.isActive === 2
                ? false
                : "",
        });
      }
    }
  }, [updateJhaHazardData]);

  const isLoading = useSelector((state) => state.getJhaHazardsList?.isLoading);

  const [selectedHazardData, setselectedHazardData] = useState({});
  function handleSetControl(data) {
    const activityName = findActivityName();
    // navigate(ADMIN_JHA_SET_CONTROLS, {
    //   state: {
    //     activityName: activityName[0].value,
    //     hazardId: data?.id,
    //     hazardName: data?.hazardsName,
    //   },
    // });
    setselectedHazardData({
      activityName: activityName[0].value,
      hazardId: data?.id,
      hazardName: data?.hazardsName,
    });
    setshowControlPage(true);
  }
  function findActivityName(params) {
    return activityList.filter((i) => i.key === formValue.activityId);
  }
  return (
    <div>
      {checkPrivileges([12, 58, 59, 60]) ? (
        <>
          <ToastContainer />
          {showControlPage ? (
            <JhaSetControlsConatiner
              activityName={selectedHazardData?.activityName}
              hazardId={selectedHazardData?.hazardId}
              hazardName={selectedHazardData?.hazardName}
              setshowControlPage={setshowControlPage}
            />
          ) : (
            <JhaHazards
              categoriesList={categoriesList ?? []}
              activityList={activityList ?? []}
              // hazardsList={hazardsListData?.data?.result?.itemList ?? []}
              hazardsList={listState ?? []}
              // itemsCount={hazardsListData?.data?.result?.itemsCount ?? []}
              itemsCount={listCountState ?? 0}
              formValue={formValue}
              setFormValue={setFormValue}
              catId={catId}
              setCatId={setCatId}
              addJhaHazard={addJhaHazard}
              isLoading={isLoading}
              handleEditOnClick={handleEditOnClick}
              handleStatusChange={handleStatusChange}
              handleSetControl={handleSetControl}
              getJhaHazardsList={getJhaHazardsList}
              setlistState={setlistState}
              setlistCountState={setlistCountState}
              filterFormValue={filterFormValue}
              setFilterFormValue={setFilterFormValue}
              hazardsListDatas={hazardsListData}
              pageSize={pageSize}
              setPageSize={setPageSize}
              page={page}
              setpage={setpage}
            />
          )}
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </div>
  );
};

export default JhaHazardsContainer;
